import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BloodBankApi } from '../api/bloodBank.api';
import { switchMap, map } from 'rxjs/operators';

import { BloodBankData, BloodBank } from '../../../interfaces/masters/bloodBank' ;
@Injectable()
export class BloodBankService extends BloodBankData {

    constructor(private api: BloodBankApi) {
      super();
    }
  
  
    list(url: string): Observable<BloodBank[]> {
      
      return this.api.list(url);
    }
  
    getById(url:string): Observable<BloodBank>{
        return this.api.getById(url);
    }
  
    create(url: string, data:BloodBank): Observable<BloodBank[]> {
      return this.api.add(url,data);
    }
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }
    update(url: string, data:BloodBank): Observable<BloodBank> {
      debugger;
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  